import { Loader } from "@components/Loader";
import { Box } from "@mui/material";
import { ReactRouterAppProvider } from "@toolpad/core/react-router";
import { Suspense, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
    DashboardHeaderProps,
    DashboardLayout,
    DashboardSidebarPageItem,
    SidebarFooterProps,
} from "@toolpad/core/DashboardLayout";

import { BackOfficeTheme } from "@themes/BackOfficeTheme.ts";
import { Navigation } from "@toolpad/core/AppProvider";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store/store";
import { signOut } from "aws-amplify/auth";

import { CustomHeader } from "@components/CustomHeader.tsx";

export const DashboardsLayout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [lateralOptions, setLateralOptions] = useState<Navigation>([]);

    const userSession = useSelector((state: RootState) => state.session.user);

    const handleLogout = async () => {
        dispatch({ type: "CLEAN_STORE" });
        await signOut();
        navigate("/");
    };

    const customHeader = (props: DashboardHeaderProps) => {
        return <CustomHeader {...props} />;
    };

    useEffect(() => {
        const lateral_options: Navigation = [
            { type: "divider" },
            { type: "segment", title: "General", segment: "dashboards" },
            { type: "divider" },
            {
                type: "segment",
                title: "Solicitudes",
                segment: "dashboards/solicitudes",
            },
            { type: "divider" },
            { type: "segment", title: "Clientes", segment: "dashboards/clientes" },
            { type: "divider" },
        ].map((option) => {
            if (option.type === "segment") {
                return {
                    type: "segment",
                    title: option.title,
                    segment: option.segment,
                };
            } else {
                return {
                    kind: "divider",
                };
            }
        });

        setLateralOptions(lateral_options);
    }, []);

    return (
        <ReactRouterAppProvider
            theme={BackOfficeTheme}
            navigation={lateralOptions}
            session={{
                user: {
                    name: userSession.name?.concat(
                        " ",
                        userSession.last_name ?? "",
                        " ",
                        userSession.last_name_2 ?? "",
                    ),
                },
            }}
            authentication={{
                signOut: handleLogout,
                signIn: () => {},
            }}
        >
            <DashboardLayout
                // renderPageItem={handleRenderPageItem}
                sidebarExpandedWidth={220}
                slots={{
                    // sidebarFooter: sidebarFooter,
                    header: customHeader,
                }}
                sx={{ backgroundColor: "#f1f2f7" }}
            >
                <Suspense fallback={<Loader />}>
                    <Box
                        id="content"
                        sx={{
                            py: 3,
                            px: 4,
                            minHeight: "100%",
                        }}
                    >
                        <Outlet />
                    </Box>
                </Suspense>
            </DashboardLayout>
        </ReactRouterAppProvider>
    );
};
